module.exports = __webpack_public_path__ + "static/media/SSS inner pages.7813a05f.pdf";